import React from 'react'
import { DEFAULT_IMAGE_URL } from 'common/constants/constants.js'
import { imgLoader } from 'common/services/imageLoader'
import { useAssetManager } from 'components/AssetManager'

import invertColor from '../../../../../util/invertColor'
import { getClassSizeCardText } from '../../utils/utils.js'
import './MemoryCard.scss'

const MemoryCard = ({ card, onTextIconClick, onCameraIconClick }) => {
    const { chooseAsset } = useAssetManager(true)

    const cardStyles = {
        backgroundImage: !card.isText ? `url(${card.src ? imgLoader(card.src) : DEFAULT_IMAGE_URL})` : null,
        backgroundColor: card.isText ? card.bgColor : null,
        color: card.isText ? invertColor(card.bgColor, true) : null,
    }

    return (
        <div className="memory-modal-pairs__card" style={cardStyles}>
            {card.isText ? (
                <p className={`memory-modal-pairs__card-text ${getClassSizeCardText(card.text.length)}`}>{card.text}</p>
            ) : null}
            <div className="memory-modal-pairs__text-svg" onClick={onTextIconClick} />
            <div className="memory-modal-pairs__camera-svg" onClick={() => chooseAsset(card.src, onCameraIconClick)} />
        </div>
    )
}

export default MemoryCard
